export default {
  isLoading: false,
  messageError: '',
};
